import 'angular';

import { OscarEventsService }       from './oscar.events.service';
import { OscarInvoicesService }     from './oscar.invoices.service';
import { OscarRequestEventCtrl }    from './oscar.request-event';
import { OscarRequestInvoiceCtrl }  from './oscar.request-invoice';
import { OscarStates }              from './oscar.states.ajs';
import { OscarSettingsCtrl }        from './oscar.settings';

angular.module('workshop.oscar', [])
.config(OscarStates)
.controller('OscarRequestEventCtrl', OscarRequestEventCtrl)
.controller('OscarRequestInvoiceCtrl', OscarRequestInvoiceCtrl)
.controller('OscarSettingsCtrl', OscarSettingsCtrl)
.factory('OscarEvents', OscarEventsService)
.factory('OscarInvoices', OscarInvoicesService);
